import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="m28.708 13.707-6 6a1 1 0 0 1-1.415-1.415L25.586 14h-4.961a11 11 0 0 0-10.654 8.25 1 1 0 0 1-1.937-.5A12.99 12.99 0 0 1 20.625 12h4.964l-4.296-4.293a1.001 1.001 0 0 1 1.415-1.415l6 6a1 1 0 0 1 0 1.415M24 26H5V11a1 1 0 1 0-2 0v15a2 2 0 0 0 2 2h19a1 1 0 0 0 0-2"
    />
  </svg>
);
const SvgIconShare = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconShare);
export default Memo;
